import { Routes } from '@angular/router';
import { AuthGuard } from './authentication/auth.guard';
import { AppBlankComponent } from './layouts/blank/blank.component';
import { FullComponent } from './layouts/full/full.component';


export const AppRoutes: Routes = [
    {
        path: '',
        canActivate: [AuthGuard],
        component: FullComponent,
        children: [
            {
                path: '',
                redirectTo: '/authentication/login',
                pathMatch: 'full'
            },
            {
                path: 'property',
                loadChildren: () => import('./property/property.module').then(x => x.PropertyModule),
                data: { rState: 0 }
            },
            {
                path: 'service-request',
                loadChildren: () => import('./service-request/service-request.module').then(x => x.ServiceRequestModule),
                data: { rState: 0 }
            },
            // {
            //     path: 'template',
            //     loadChildren: () => import('./listing-template/listing-template.module').then(x => x.ListingTemplateModule),
            //     data: { rState: 0 }
            // },
            {
                path: "profile",
                loadChildren: () => import('./Profile/profile.module').then(x => x.ProfileModule),
                data: { rState: 0 }
            },
            {
                path: "tenant-sales-collection",
                loadChildren: () => import('./tenant-sales-collection-listing/tenant-sales-collection-listing.module')
                    .then(x => x.TenantSalesCollectionListingModule),
                data: { rState: 0 }
            },
            {
                path: "routine-inspection",
                loadChildren: () => import('./routine-inspection/routine-inspection.module').then(x => x.RoutineInspectionModule),
                data: { rState: 0 }
            },
            {
                path: "meter",
                loadChildren: () => import('./meter-utility/meter.module').then(x => x.MeterModule),
                data: { rState: 0 }
            },
            {
                path: 'news',
                loadChildren: () => import('./news/news.module').then(x => x.NewsModule),
                data: { rState: 0 }
            },
            {
                path: 'template',
                loadChildren: () => import('./template/template.module').then(x => x.TemplateModule),
                data: { rState: 0 }
            },

        ]
    },
    {
        path: '',
        component: AppBlankComponent,
        children: [
            {
                path: 'authentication',
                loadChildren: () => import('./authentication/authentication.module').then(x => x.AuthenticationModule),
                data: { rState: 0 }
            }
        ]
    },
    {
        path: 'leaseoperation',
        redirectTo: 'authentication/login',
        data: { rState: 0 }
    },
    {
        path: '**',
        redirectTo: 'authentication/404',
        data: { rState: 0 }
    }
];
